module.exports = __webpack_public_path__ + "static/img/004-student.f7ea50a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/004-student.png
// module id = 353
// module chunks = 2